/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventParameter } from './EventParameter';
import {
    EventParameterFromJSON,
    EventParameterFromJSONTyped,
    EventParameterToJSON,
} from './EventParameter';
import type { HookAction } from './HookAction';
import {
    HookActionFromJSON,
    HookActionFromJSONTyped,
    HookActionToJSON,
} from './HookAction';

/**
 * Either action_id or action_override must be provided, but not both
 * @export
 * @interface TestHookActionPayload
 */
export interface TestHookActionPayload {
    /**
     * 
     * @type {string}
     * @memberof TestHookActionPayload
     */
    action_id?: string;
    /**
     * 
     * @type {HookAction}
     * @memberof TestHookActionPayload
     */
    action_override?: HookAction;
    /**
     * 
     * @type {Array<EventParameter>}
     * @memberof TestHookActionPayload
     */
    mock_event_data?: Array<EventParameter>;
}

/**
 * Check if a given object implements the TestHookActionPayload interface.
 */
export function instanceOfTestHookActionPayload(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TestHookActionPayloadFromJSON(json: any): TestHookActionPayload {
    return TestHookActionPayloadFromJSONTyped(json, false);
}

export function TestHookActionPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestHookActionPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action_id': !exists(json, 'action_id') ? undefined : json['action_id'],
        'action_override': !exists(json, 'action_override') ? undefined : HookActionFromJSON(json['action_override']),
        'mock_event_data': !exists(json, 'mock_event_data') ? undefined : ((json['mock_event_data'] as Array<any>).map(EventParameterFromJSON)),
    };
}

export function TestHookActionPayloadToJSON(value?: TestHookActionPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action_id': value.action_id,
        'action_override': HookActionToJSON(value.action_override),
        'mock_event_data': value.mock_event_data === undefined ? undefined : ((value.mock_event_data as Array<any>).map(EventParameterToJSON)),
    };
}

